import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AppRoute from "./Routes/Route";
import DisableBrowserAutofill from "./Components/DisableBrowserAutofill";
import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createEmsTheme } from "./theme/emsMuiTheme";

function App() {
  const theme = React.useMemo(() => createEmsTheme("light"), []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DisableBrowserAutofill />
        <AppRoute/>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
